'use client';

import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { classNames } from "../../utils/styles/classNames.js";
import { visuallyHidden } from "../../../css-utils.js";
import { colors, variants, base } from "./Text.css.js";
import { defaultProps } from "./Text.defaultProps.js";
function TextComponent({
  children,
  dataQa,
  variant: variantProp,
  color: colorProp,
  as: asProp,
  visuallyHidden: visuallyHidden$1,
  className,
  ...props
}, ref) {
  const variant = variantProp || defaultProps.variant;
  const color = colorProp || defaultProps.color;
  const as = asProp || defaultProps.as;
  const Element = as;
  return /* @__PURE__ */ jsx(
    Element,
    {
      className: classNames(
        base,
        className,
        variants[variant],
        colorProp && colors[color],
        visuallyHidden$1 && visuallyHidden
      ),
      "data-qa": dataQa,
      ref,
      ...props,
      children
    }
  );
}
const Text = /* @__PURE__ */ memo(
  forwardRef(TextComponent)
);
export {
  Text
};
